<!-- 现场活动 -->
<template>
    <div class="scene-activity-container">
        <roof-search v-if="showNav" :middleContent="false" :rightContent="false"></roof-search>
        <div class="scene-activity">
            <div class="top-nav">
                <div class="nav" :class="currentNavIndexOf == index?'pitch-on':''" v-for="(item,index) in navList" :key="index" @click="pickOn(index)">{{item}}</div>
            </div>
            <div class="activity-list footer" ref="activity_scroll" @scroll="activityScroll">
                <div class="item" v-for="(item,index) in activityList" :key="index" @click="goDetails(item)">
                    <div class="left-cover">
                        <img class="cover-img" :src="cdnUrl+JSON.parse(item.img_url)" alt="">
                    </div>
                    <div class="right-content">
                        <div class="top-title van-multi-ellipsis--l2">{{item.title}}</div>
                        <div class="bottom-con">
                            <div class="left-hint">
                                <p class="date" v-if="item.is_line == 0">{{item.start_date1}}-{{item.end_date1}}</p>
                                <p class="date" v-else>{{item.start_date2}}</p>
                                <p class="address">{{item.address}}</p>
                            </div>
                            <!--              <button class="right-btn" v-if="is_active == 1">立即报名</button>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import { wxShare } from '@/libs/wxjssdk'
import { getActivityList } from '@/api/activity'
export default {
    components: {
        roofSearch
    },
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            navList: ['近期活动', '往期活动'],
            is_active: 1, // 1近期 0往期
            showNav: true,
            currentNavIndexOf: 0,
            activityList: [],
            page: 1, // 当前页码
            pageSize: 10, // 一页显示10个
            last_page: 1 // 最后一页的页码
        }
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    created () {
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        this.getActivityList()
    },
    activated () {
        this.showNav = true
        this.sharePage()
        // console.log('进入列表页面');
        localStorage.removeItem('defalFrom')
        localStorage.removeItem('cusFrom')
    },
    deactivated () {
        this.showNav = false
    },
    mounted () {
        this.sharePage()
    },
    methods: {
        sharePage () {
            const params = {
                title: '小 E 活动', // 分享标题
                desc: '小 E 活动', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 150 // 距离底部距离
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    })
                    this.getActivityList()
                }
            }
        },
        // 单击了导航
        pickOn (index) {
            this.currentNavIndexOf = index
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
            switch (index) {
            case 0:
                this.is_active = 1
                break
            case 1:
                this.is_active = 0
                break
            }
            this.page = 1
            this.activityList = []
            this.getActivityList()
        },
        // 跳转活动详情
        goDetails (item) {
            this.$router.push({
                name: 'activityDetail',
                query: {
                    id: item.id
                }
            })
        },
        /** 网络请求 **/
        // 获取活动列表
        getActivityList () {
            var params = {
                page: this.page,
                type: 2, // 1公司活动 2现场活动
                is_active: this.is_active
            }
            getActivityList(params).then((res) => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.last_page = data.last_page
                    var activityList = data.data
                    activityList.map((val) => {
                        val.start_date1 = val.start_date.split(' ')[0].substr(5, 5).replace('-', '.')
                        val.start_date2 = val.start_date.substr(0, 16).replace(/-/g, '.')
                        val.end_date1 = val.end_date.split(' ')[0].substr(5, 5).replace('-', '.')
                    })
                    this.activityList.push(...activityList)
                    this.$toast.clear()
                } else {
                    this.$toast(res.errMsg)
                }
                this.$toast.clear()
            }).catch((err) => {
                console.log('活动列表接口失败', err)
                this.$toast('活动列表接口失败')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.scene-activity-container {
    position: relative;
    background: #fff;
    width: 100%;
    height: 100vh;
    .scene-activity {
        width: 100%;
        height: 100vh;
        padding-top: rem(46);
        display: flex;
        flex-direction: column;
        .top-nav {
            display: flex;
            align-items: center;
            justify-content: center;
            height: rem(70);
            .nav {
                width: rem(103);
                height: rem(30);
                border: 2px solid $base-color;
                display: flex;
                align-items: center;
                justify-content: center;
                color: $base-color;
                font-size: 13px;
                border-radius: 4px;
                &:first-child {
                    margin-right: rem(30);
                }
            }
            .pitch-on {
                background: $base-color;
                color: #fff;
                transition: all 0.2s;
            }
        }
        .activity-list {
            flex: 1;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            padding: 0 rem(20);
            .item {
                height: rem(100);
                margin-bottom: rem(20);
                display: flex;
                .left-cover {
                    width: rem(160);
                    height: 100%;
                    border-radius: 4px;
                    background: #cfcfcf;
                    .cover-img {
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                    }
                }
                .right-content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: rem(3) rem(8);
                    .top-title {
                        color: #2c2c2c;
                        font-size: rem(14);
                    }
                    .bottom-con {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .left-hint {
                            color: #9d9d9d;
                            font-size: rem(11);
                        }
                        .right-btn {
                            width: rem(68);
                            height: rem(25);
                            background: $base-color;
                            border-radius: 4px;
                            color: #fff;
                            font-size: rem(11);
                            outline: none;
                            border: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
